import { Component, computed, input, output, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ClientRequestItemStatus } from '@aiwyn/api';
import { AddNoteModalComponent } from '../../../../../../../components/add-note-modal/add-note-modal.component';
import { AddNoteModalData } from '../../../../../../../components/add-note-modal/add-note-modal.model';

@Component({
  selector: 'awn-not-applicable-content',
  templateUrl: './not-applicable-content.component.html',
  styleUrls: ['./not-applicable-content.component.scss'],
  standalone: false
})
export class NotApplicableContentComponent {
  hasUploadedFiles = input<boolean>(false);
  requestItemStatus = input<ClientRequestItemStatus>();
  dataSelector = input<string>('');
  isNotApplicable = input<boolean>(false);
  requestItemId = input.required<number>();
  requestItemName = input.required<string>();
  existingNote = input<string | null>(null);
  isItemRestricted = input<boolean>(false);
  
  notApplicableChange = output<{
    isNotApplicable: boolean;
    notApplicableReason?: string;
  }>();

  // Internal signal that syncs with input
  private _isNotApplicable = signal<boolean>(false);

  // Computed text for the button
  noteButtonText = computed(() => {
    return this.existingNote() ? 'Edit Note' : 'Add note';
  });

  constructor(private dialog: MatDialog) {}

  isNotEditableStatus = computed(() => {
    return this.requestItemStatus() === ClientRequestItemStatus.IN_REVIEW || this.requestItemStatus() === ClientRequestItemStatus.DONE;
  });

  isCheckboxDisabled = computed(() =>
    this.isNotEditableStatus() || this.hasUploadedFiles() || this.isItemRestricted()
  );

  showAddNoteButton = computed(() => {
    return this.isNotApplicable() && !this.isCheckboxDisabled();
  });

  tooltipMessage = computed(() => 
    this.hasUploadedFiles() && !this.isNotEditableStatus()
      ? 'Remove files from the request to mark as not applicable' 
      : ''
  );

  onNotApplicableChange(checked: boolean): void {
    this._isNotApplicable.set(checked);
    this.notApplicableChange.emit({ isNotApplicable: checked });
  }

  onAddNote(): void {
    const dialogRef = this.dialog.open<AddNoteModalComponent, AddNoteModalData>(
      AddNoteModalComponent,
      {
        width: '500px',
        data: {
          requestItemId: this.requestItemId(),
          requestItemName: this.requestItemName(),
          existingNote: this.existingNote() || ''
        }
      }
    );

    dialogRef.afterClosed().subscribe(result => {
      if (result?.saved) {
        // Emit both N/A state and note to parent
        this.notApplicableChange.emit({ 
          isNotApplicable: true, 
          notApplicableReason: result.note 
        });
      }
    });
  }
}